import StyledLink from '../StyledLink'
import useModule from '../../hooks/useModule'
import {
  ADD,
  CONTROLLER,
  MONITOR,
  MONITOR_CONFIG,
  TEST_CONFIG
} from '../routes'
import type { Props } from '../types'

const LinkToAddTestConfig = ({
  children,
  isHyperlink
}: Props) => {
  const [isMonitorFlag] = useModule()

  const routingPath = !isMonitorFlag
    ? '/' + CONTROLLER + '/' + TEST_CONFIG + '/' + ADD
    : '/' + MONITOR + '/' + MONITOR_CONFIG + '/' + ADD

  return (
    <StyledLink
      isHyperlink={isHyperlink}
      to={routingPath}
    >
      {children}
    </StyledLink>
  )
}

export default LinkToAddTestConfig
